import React, { useEffect, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Paper,
  Typography,
  Grid,
  Stack,
  IconButton,
  Tooltip,
  Card,
} from "@mui/material";
import FlagIcon from "@mui/icons-material/Flag";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { Icon } from "@iconify/react";
import IconBox from "./component/IconBox";
import CustomCardWithBorder from "../../../components/CustomCardWithBorder";
import { getLessonPlan, getLessonPlanForOneDay } from "./services/lessonplan";
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";
import GlobalCard from "../../../components/GlobalCardComponent";

// ... imports remain the same

export default function LessonPlanner({ classDetails }) {
  console.log("classDetails", classDetails);
    const currentDate = new Date().toISOString().split("T")[0];

  const navigate= useNavigate()
  const [activeDay, setActiveDay] = useState(0);
  const [days, setDays] = useState([]);
  const [currentDayData, setCurrentDayData] = useState(null);

  const userId = localStorage.getItem("userId");
  const [showNoLessonPlanScreen, setShowNoLessonPlanScreen] = useState(false);

  const handleFetchLessonPlan = async () => {
    const payload = {
      sp_user_id: Number(userId),
      std_class_detail_id: classDetails?.id,
    };

    try {
      const response = await getLessonPlan(payload);

      if (response?.data?.length) {
        setDays(response.data);
        const currentDay = response.data?.find(
          (day) => day.is_current_day === true,
        );
        setActiveDay(currentDay?.day_number - 1);
        // Auto load first day data
        fetchSingleDay(currentDay);
         setShowNoLessonPlanScreen(false);
      } else {
        setShowNoLessonPlanScreen(true);
      }

    } catch (error) {
      console.error("Error fetching lesson plan:", error);
       setShowNoLessonPlanScreen(true);
    }
  };

  useEffect(() => {
    handleFetchLessonPlan();
  }, []);

  const fetchSingleDay = async (day) => {
    if (!day) return;

    const payload = {
      sp_user_id: Number(userId),
      plan_id: day.plan_id,
      day_number: day.day_number,
    };

    try {
      const response = await getLessonPlanForOneDay(payload);

      setCurrentDayData(response?.data || null);
    } catch (error) {
      console.error("Error fetching single day:", error);
    }
  };

  // useEffect(() => {
  //   if (classDetails?.id) {
  //     handleFetchLessonPlan();
  //   }
  // }, [classDetails]);

  const handleTabChange = (e, newValue) => {
    setActiveDay(newValue);

    const selectedDay = days[newValue];

    if (selectedDay && !selectedDay.is_lock) {
      fetchSingleDay(selectedDay);
    }
  };

  const currentDay = currentDayData;

  console.log("activeDay", activeDay);

  return (
    <>
     {currentDate < classDetails?.enrollment_date ? (
       <Card
                sx={{
                  borderRadius: "12px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  borderLeft: "4px solid #FBADEF", // purple left border
                  mb: 2,
                  p: "15px",
                  //  height: "350px",

                  // height: "100%",
                }}
              >
                <Grid container spacing={2} display="flex" alignItems="center" justifyContent="center" >
                  <Grid item xs={12}>
                    <Typography
                      color="#000000"
                      fontFamily="Inter"
                      fontSize="18px"
                      lineHeight="100%"
                      letterSpacing="0px"
                      fontStyle="normal"
                      style={{ fontWeight: 400 }}
                    >
                     {/* Lesson Plan */}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    container
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                    gap={2}
                    mt={2}
                  >
                    <Box width={70}>
                      <img src="/newdashboard/Classrom/prohibited-book.png" />
                    </Box>
                    <Typography
                      color="#9D0385"
                      fontFamily="Inter"
                      fontSize="18px"
                      lineHeight="100%"
                      letterSpacing="0px"
                      fontStyle="normal"
                      style={{ fontWeight: 400 }}
                      mt={1}
                    >
                        Lesson Plan Not Available Yet
                    </Typography>

                    <Typography
                      color="#454545"
                      fontFamily="Inter"
                      fontSize="14px"
                      lineHeight="1.6"
                      letterSpacing="0px"
                      fontStyle="normal"
                      textAlign="center"
                      style={{ fontWeight: 400 }}
                      px={5}
                    >
                   Lesson plans will be visible once your classes begin. <br/>
                  Please check back later.
                    </Typography>
                  </Grid>
                </Grid>
              </Card>
     ): 
    showNoLessonPlanScreen ? (
      <>
      <Card
                sx={{
                  borderRadius: "12px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  borderLeft: "4px solid #FBADEF", // purple left border
                  mb: 2,
                  p: "15px",
                  //  height: "350px",

                  // height: "100%",
                }}
              >
                <Grid container spacing={2} display="flex" alignItems="center" justifyContent="center" >
                  <Grid item xs={12}>
                    <Typography
                      color="#000000"
                      fontFamily="Inter"
                      fontSize="18px"
                      lineHeight="100%"
                      letterSpacing="0px"
                      fontStyle="normal"
                      style={{ fontWeight: 400 }}
                    >
                     {/* Lesson Plan */}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    container
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                    gap={2}
                    mt={2}
                  >
                    <Box width={70}>
                      <img src="/newdashboard/Classrom/prohibited-book.png" />
                    </Box>
                    <Typography
                      color="#9D0385"
                      fontFamily="Inter"
                      fontSize="18px"
                      lineHeight="100%"
                      letterSpacing="0px"
                      fontStyle="normal"
                      style={{ fontWeight: 400 }}
                      mt={1}
                    >
                     Lesson Plan Not Available Yet
                    </Typography>

                    <Typography
                      color="#454545"
                      fontFamily="Inter"
                      fontSize="14px"
                      lineHeight="1.6"
                      letterSpacing="0px"
                      fontStyle="normal"
                      textAlign="center"
                      style={{ fontWeight: 400 }}
                      px={5}
                    >
                  No lesson plan is available at the moment. Please check back later.
                    </Typography>
                  </Grid>
                </Grid>
              </Card>
              </>
    ) :( <>
    <Box
      sx={{
        width: "100%",
        maxWidth: {
          xs: 375,
          sm: 600,
          md: 700,
          lg: 900,
          xl: 1200,
        },

        position: "relative",
      }}
    >
      <Box width="100%">
        {/* Tabs Container */}
        <GlobalCard>
            <Grid container spacing={2} pr={2}>
                  <Grid item xs={12}>
                    <Typography
                      color="#000000"
                      fontFamily="Inter"
                      fontSize="20px"
                      lineHeight="100%"
                      letterSpacing="0px"
                      fontStyle="normal"
                      style={{ fontWeight: 400 }}
                    >
                  Lesson Plan
                    </Typography>
                  </Grid>
                      <Grid item xs={12}>
                            <Box>
                              <img src="/newdashboard/Classrom/Rectangle 111141662.png" />
                            </Box>
                          </Grid>
                </Grid>
   <Paper
  elevation={0}
  sx={{
    p: 2,
    borderRadius: 3,
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
      height: "300px", // fixed height
            overflowY: "auto", // vertical scroll
            overflowX: "hidden", // optional (hide horizontal)
            /* Scrollbar Styling */
            "&::-webkit-scrollbar": {
              width: "5px", // 👈 decrease size
            },

            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },

            "&::-webkit-scrollbar-thumb": {
              background: "#c1c1c1",
              borderRadius: "10px",
            },

            "&::-webkit-scrollbar-thumb:hover": {
              background: "#999",
            },

            /* Firefox */
            scrollbarWidth: "thin",
            scrollbarColor: "#c1c1c1 transparent",
          
  }}
>
  {days?.map((day, i) => {
    const isActive = activeDay === i;

    return (
      <Tooltip
        key={i}
        title={
          day.is_lock
            ? "This lesson is locked. Complete previous days first."
            : ""
        }
        arrow
      >
        <Box
          onClick={() => {
  if (!day.is_lock) {
    window.open(
      `/test-prep/lesson/${day.plan_id}/${day.day_number}`,
      "_blank",
    );
  }
}}

          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 1.5,
            borderRadius: 2,
            cursor: day.is_lock ? "not-allowed" : "pointer",
            border: "1px solid",

            // Colors
            backgroundColor: isActive
              ? "#572575"
              : day.is_lock
              ? "#f5f5f5"
              : "#fff",

            borderColor: isActive
              ? "#572575"
              : "#e0e0e0",

            color: isActive
              ? "#fff"
              : day.is_lock
              ? "#999"
              : "#572575",

            transition: "all 0.2s",

            "&:hover": {
              backgroundColor:
                !day.is_lock && !isActive
                  ? "#f9f2fc"
                  : undefined,
            },
          }}
        >
          {/* Left Side */}
          <Box>
            <Typography fontWeight={700} fontFamily="Inter">
              Day {String(day.day_number).padStart(2, "0")}
            </Typography>

            <Typography
              fontSize={13}
              fontFamily="Inter"
              color={isActive ? "#fff" : "text.secondary"}
            >
              {day.topic || "-"}
            </Typography>
          </Box>

          {/* Right Side Icon */}
          <Box>
            {day.is_lock ? (
              <Icon icon="twemoji:locked" width={18} />
            ) : isActive ? (
              <Icon icon="mdi:check-circle" width={20} />
            ) : (
              <Icon icon="mdi:chevron-right" width={20} />
            )}
          </Box>
        </Box>
      </Tooltip>
    );
  })}
</Paper>
</GlobalCard>
       
      </Box>
    </Box>
    </>) }
    </>
  );
}
